/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPropeller = createReactComponent("propeller", "IconPropeller", [
  ["path", { d: "M12 13m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-0" }],
  [
    "path",
    {
      d: "M14.167 10.5c.722 -1.538 1.156 -3.043 1.303 -4.514c.22 -1.63 -.762 -2.986 -3.47 -2.986s-3.69 1.357 -3.47 2.986c.147 1.471 .581 2.976 1.303 4.514",
      key: "svg-1"
    }
  ],
  [
    "path",
    {
      d: "M13.169 16.751c.97 1.395 2.057 2.523 3.257 3.386c1.3 1 2.967 .833 4.321 -1.512c1.354 -2.345 .67 -3.874 -.85 -4.498c-1.348 -.608 -2.868 -.985 -4.562 -1.128",
      key: "svg-2"
    }
  ],
  [
    "path",
    {
      d: "M8.664 13c-1.693 .143 -3.213 .52 -4.56 1.128c-1.522 .623 -2.206 2.153 -.852 4.498s3.02 2.517 4.321 1.512c1.2 -.863 2.287 -1.991 3.258 -3.386",
      key: "svg-3"
    }
  ]
]);

export { IconPropeller as default };
//# sourceMappingURL=IconPropeller.js.map
